"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
function ToolsCutOptionsButton({ children, selected, className, onClick, }) {
    return ((0, jsx_runtime_1.jsx)(Container, { className: className, selected: selected, onClick: onClick, role: "button", "aria-label": "cutToolOption", "data-e2e": 'ToolsCutOptionsButton_Container', children: children }));
}
exports.default = ToolsCutOptionsButton;
const Container = (0, styled_components_1.default)(ui_1.BaseButton) `
  position: relative;

  width: 50px;
  height: 50px;

  margin: 0;
  padding: 0;

  color: ${props => (props.selected ? props.theme.white : props.theme.text)};

  background-color: ${props => props.selected
    ? props.theme.quizzes.answerText
    : props.theme.tools.cut.button.background};

  border-radius: 50%;

  transition-timing-function: ease-in;
  transition-duration: 0.2s;
  transition-property: color, background-color, fill;

  fill: ${props => props.selected
    ? props.theme.tools.cut.button.fillSelected
    : props.theme.tools.cut.button.fill};

  &::before {
    position: absolute;
    top: -4px;
    right: -4px;
    bottom: -4px;
    left: -4px;

    border: 4px solid
      ${props => (props.selected ? props.theme.white : 'transparent')};

    border-radius: 50%;

    transition-timing-function: ease-in;
    transition-duration: 0.2s;
    transition-property: border;

    content: ' ';
  }
`;
